// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config, spacing } = window.BAO.Carousel
const {
  setInitialised,
  addWheelControls,
  useDots,
} = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils
class ProductReassuranceMessaging extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onResize = this.onResize.bind(this)
    this.debouncedResize = debounce(event => {
      this.onResize(event)
    }, 500)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  setupCarousel () {
    return new KeenSlider(this.els.slides.element, this.options(), [
      setInitialised(),
      addWheelControls('horizontal'),
      useDots(this.els?.dot?.elements),
      slider => {
        const screenWidth = window.innerWidth
        if (screenWidth < 768 || screenWidth >= 1200) {
          return
        }
        let timeout
        let mouseOver = false
        function clearNextTimeout () {
          clearTimeout(timeout)
        }
        function nextTimeout () {
          clearTimeout(timeout)
          if (mouseOver) return
          timeout = setTimeout(() => {
            slider.next()
          }, 2000)
        }
        slider.on('created', () => {
          slider.container.addEventListener('mouseover', () => {
            mouseOver = true
            clearNextTimeout()
          })
          slider.container.addEventListener('mouseout', () => {
            mouseOver = false
            nextTimeout()
          })
          nextTimeout()
        })
        slider.on('dragStarted', clearNextTimeout)
        slider.on('animationEnded', nextTimeout)
        slider.on('updated', nextTimeout)
      },
    ])
  }

  options () {
    return {
      selector: this.els.slide.selector,
      loop: true,
      mode: 'free-snap',
      defaultAnimation: {
        duration: config.defaultAnimation.duration,
      },
      initial: 1,
      dragSpeed: config.dragSpeed,
      slides: {
        origin: 'center',
        perView: 'auto',
        spacing: 46,
      },
      renderMode: 'custom',
      detailsChanged: s => {
        const screenWidth = window.innerWidth
        if (screenWidth < 768 || screenWidth >= 1200) {
          return
        }
        s.slides.forEach((element, idx) => {
          element.style.opacity = s.track.details.slides[idx].portion
        })
      },
      breakpoints: {
        '(max-width: 767px)': {
          loop: false,
          renderMode: 'performance',
        },
        '(min-width: 768px)': {
          slides: {
            perView: '1',
            spacing: spacing(),
            renderMode: 'custom',
          },
        },
        '(min-width: 1199px)': {
          slides: {
            perView: '3',
            spacing: spacing(),
            renderMode: 'performance',
          },
        },
      },
    }
  }

  onResize () {
    if (!this.carousel) return
    this.carousel.update(this.options(), this.carousel.track.details.rel)
  }
}

if (!customElements.get('product-reassurance-messaging')) {
  customElements.define(
    'product-reassurance-messaging',
    ProductReassuranceMessaging,
  )
}
